import React from 'react'
import {Heading as HeadingChakra, HeadingProps} from '@chakra-ui/react'

export const Heading = (props: HeadingProps) => {
  return <HeadingChakra {...props}></HeadingChakra>
}
export default Heading
